// eslint-disable-next-line max-classes-per-file
import angular from 'angular';
import template from '~/scripts/services/modal/template.html';

export class ModalController {
	/** @type {angular.ui.bootstrap.IModalInstanceService} */
	$uibModalInstance;

	/**
	 *
	 * @param {*} options
	 * @param {angular.ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {angular.auto.IInjectorService} $injector
	 */
	constructor(options, $uibModalInstance, $injector) {
		this.options = options;
		this.$uibModalInstance = $uibModalInstance;
		this.$injector = $injector;
		this.$close = $uibModalInstance.close;
		this.$dismiss = $uibModalInstance.dismiss;
		this.actions = {
			close:   this.$close,
			dismiss: this.$dismiss,
		};
	}
}

export class TemporaryController extends ModalController {
	/* @ngInject */
	/**
	 * @param {any} options
	 * @param {angular.ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {angular.auto.IInjectorService} $injector
	 */
	// eslint-disable-next-line no-useless-constructor
	constructor(options, $uibModalInstance, $injector) {
		super(options, $uibModalInstance, $injector);
	}
}

/**
 * @typedef {Object} Button
 * @property {string} label The text of the button
 * @property {any} [value] A string to identify the result
 * @property {"close"|"dismiss"} [action] The action associated with the button
 * @property {"success"|"danger"|"default"|"warning"|"primary"|"secondary"|"info"} [type] The type of button
 */

/**
 * @typedef {Object} ModalOptions
 * @property {string} title The title of the modal
 * @property {string} body The body of the modal
 * @property {Array<Button>} [buttons] An array of buttons
 */

/**
 * @typedef {Object} AlertOptions
 * @property {Button} [accept] The accept button
 */

/**
 * @typedef {Object} ConfirmOptions
 * @property {Button} [accept] The accept button
 * @property {Button} [cancel] The cancel button
 */

// eslint-disable-next-line jsdoc/valid-types
/**
 * @typedef {AlertOptions & ModalOptions} AlertModal
 */

// eslint-disable-next-line jsdoc/valid-types
/**
 * @typedef {ConfirmOptions & ModalOptions} ConfirmModal
 */

export class Modal {
	/** @type {angular.ui.bootstrap.IModalService} */
	$uibModal;

	/* @ngInject */
	/**
	 * @param {angular.auto.IInjectorService} $injector
	 */
	constructor($injector) {
		this.$uibModal = $injector.get('$uibModal');
		this.$translate = $injector.get('$translate');

		this.$injector = $injector;

		this.template = template;
		this.controller = TemporaryController;
	}

	/**
	 * @param {angular.ui.bootstrap.IModalSettings} dialogOptions Options of the dialog
	 * @param {*} controllerData Custom data passed to the controller
	 * @returns {Promise<*>} The result
	 */
	open(dialogOptions, controllerData) {
		this.modal = this.$uibModal.open({
			backdrop:     'static',
			controller:   this.controller,
			template:     this.template,
			controllerAs: '$ctrl',
			resolve:      {
				options: () => controllerData,
			},

			// override options
			...dialogOptions,
		});

		// @ts-ignore
		return this.modal.result;
	}

	/**
	 *
	 * @param  {any} [arguments_]
	 */
	close(...arguments_) {
		this.modal?.close(...arguments_);
	}
}

export class Confirm extends Modal {
	/**
	 * @param {ConfirmModal} confirmOptions confirm options
	 * @returns {Promise<boolean>} return
	 */
	// @ts-ignore
	open(confirmOptions) {
		const { cancel, accept, ...rest } = confirmOptions;
		return super.open({}, {
			buttons: [
				{
					action: 'close',
					value:  false,
					label:  this.$translate.instant('common.cancel'),
					type:   'default',
					...cancel,
				},
				{
					action: 'close',
					value:  true,
					label:  this.$translate.instant('common.confirm'),
					type:   'success',
					...accept,
				},
			],
			...rest,
		});
	}
}

export class Alert extends Modal {
	/**
	 * @param {AlertModal} alertOptions alert options
	 * @returns {Promise<boolean>} return
	 */
	// @ts-ignore
	open(alertOptions) {
		const { accept, ...rest } = alertOptions;

		return super.open({}, {
			buttons: [
				{
					action: 'close',
					value:  true,
					label:  'OK',
					type:   'default',
					...accept,
				},
			],
			...rest,
		});
	}
}
